import { Component } from '../../engine/Component';

export default class PresentationComponent extends Component {
  static get code(): string {
    return 'presentation';
  }
}
